import { combineReducers } from 'redux';

import auth from './auth';
import offers from './dashboard';
import charges from './charges';
import confirmationDialog from './confirmationDialog';
import portfolioManager from './portfolioManager';
import report from './reports';
import flagOffer from './flagOffer';
import properties from './properties';
import renewalDashboard from './renewalDashboard';
import notification from './notification';
import leasePricing from './leasePricing';
import unifiedLeasePricingReducer from './leasePricingUnified';
import tenantSegments from './tenants';
import settings from './settings';
import strategy from './strategy';
import { reportsReducer as reports } from './newReports';
import NoWalkScore from './nowalk';
import sfrLeasePricing from './sfrLeasePricing';
import reportV2 from './reportsv2';
import downloads from './downloads';
import uploadToPMSReducer from './uploadToPMS';
import taskLogs from './taskLogs';
import propertyPortfolio from './propertyPortfolio';

const rootReducer = combineReducers({
  auth,
  offers,
  charges,
  confirmationDialog,
  portfolioManager,
  report,
  flagOffer,
  properties,
  renewalDashboard,
  notification,
  leasePricing,
  unifiedLeasePricing: unifiedLeasePricingReducer,
  tenantSegments,
  reports,
  NoWalkScore,
  strategy,
  settings,
  sfrLeasePricing,
  reportV2,
  downloads,
  uploadToPMS: uploadToPMSReducer,
  taskLogs,
  propertyPortfolio,
});

export default rootReducer;
